import { useTranslations } from 'next-intl';
import { InnerHTML } from '@headless-workspace/domain/common/client';
import { GlowTextBody, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { PaymentMethodsValue } from 'domains/common/src/server/lib/productDetail/';

type ProductDetailBuyNowPayLaterTextProps = PropsWithFontFamily & {
    buyNowPayLaterContent: PaymentMethodsValue;
};

export const ProductDetailBuyNowPayLaterText: Component<ProductDetailBuyNowPayLaterTextProps> = ({
    buyNowPayLaterContent,
    fontFamily,
}) => {
    const t = useTranslations('Discover.Pdp.information.paymentMethods');

    const paymentMethods = buyNowPayLaterContent.items
        ?.map(
            (element) =>
                `<a class='text-underline' href='${buyNowPayLaterContent.paymentMethodsUrl}'>
                ${element.name}
            </a>`,
        )
        .reverse();

    const [last, ...rest] = paymentMethods ?? [];
    const firsts = rest.length > 0 ? rest.join(',') : '';
    const content = `
        <p>
            ${t('label.buyNowPayLater', {
                firsts,
                last,
            })}
        </p>`;

    return <GlowTextBody fontFamily={fontFamily} className={'mt-1'} innerHTML={<InnerHTML rawHtml={{ content }} />} />;
};
